<template>
  <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">Home / faq</div>
            <h1 class="text-3xl font-bold">FAQs</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20">
      <div class="max-w-7xl mx-auto">
        <div class="mb-5">
          <form @submit.prevent="onSearchSubmit">
            <input
              v-model="searchStr"
              type="search"
              placeholder="Search"
              class="form-control rounded-full w-full"
            />
          </form>
        </div>
        <div>
          <!-- <div class="" v-for="faq in rows" :key="faq.id">
            <h2 class="mb-3 font-bold text-lg">{{ faq.name }}</h2>
            <Accordion>
              <AccordionItem v-for="row in faq.faqs" :key="row.id" class="mb-5">
                <template v-slot:accordion-trigger>
                  {{ row.question }}
                </template>
                <template v-slot:accordion-content>
                  <div class="p-5">{{ row.answer }}</div>
                </template>
              </AccordionItem>
            </Accordion>
          </div> -->
          <Accordion>
            <AccordionItem class="mb-5" v-for="faq in rows" :key="faq.id">
              <h2 class="mb-3 font-bold text-lg">{{ faq.name }}</h2>
              <template v-slot:accordion-trigger>
                {{ faq.name }}
              </template>
              <template v-slot:accordion-content>
                <div class="p-5">
                  <Accordion>
                    <AccordionItem
                      v-for="row in faq.faqs"
                      :key="row.id"
                      class="mb-5"
                    >
                      <template v-slot:accordion-trigger>
                        {{ row.question }}
                      </template>
                      <template v-slot:accordion-content>
                        <div class="p-5">{{ row.answer }}</div>
                      </template>
                    </AccordionItem>
                  </Accordion>
                </div>
              </template>
            </AccordionItem>
          </Accordion>
          <!-- <pre>
            {{ searchList }}
          </pre> -->
        </div>
      </div>
    </div>
  </section>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import SectionFooter from "@/components/SectionFooter";
import { useStore } from "vuex";
import { computed, onMounted, ref } from "@vue/runtime-core";
import Accordion from "@/components/accordion/Accordion.vue";
import AccordionItem from "@/components/accordion/AccordionItem.vue";

const store = useStore();
const rows = ref([]); // computed(() => store.getters["faq/data"].rows);

function init() {
  store
    .dispatch("http/send", {
      module: "faq",
    })
    .then((res) => {
      rows.value = res.data;
    });
}

init();

onMounted(() => {
  document.title = "FAQ - The Coral Database";
  document
    .querySelector('meta[name="description"]')
    .setAttribute(
      "content",
      "Frequently asked questions regarding the Coral Database"
    );
});

const searchStr = ref("");

function onSearchSubmit() {
  if (searchStr.value !== "") {
    store
      .dispatch("http/send", {
        module: "faqSearch",
        params: {
          query: searchStr.value,
        },
      })
      .then((res) => {
        rows.value = res.data;
      });
  } else {
    init();
  }
}

let searchList = computed(() => {
  var forms = [];
  if (searchStr.value.indexOf(" ") > 0) {
    let words = searchStr.value.split(" ");
    forms = [];
    words.forEach((word) => {
      if (word.length > 1) {
        rows.value.forEach((element) => {
          if (formSearch(word, element)) {
            if (!forms.find((f) => f.id == element.id)) {
              forms.push(element);
            }
          }
        });
      }
    });
  } else if (searchStr.value.length > 1) {
    rows.value.forEach((element) => {
      if (formSearch(searchStr.value, element)) {
        // console.log("Found");
        forms.push(element);
      }
    });
  } else {
    // forms = this.apps.applications;
  }
  return forms;
});

function formSearch(searchQuery, element) {
  //   console.log(element);
  var keywords = element["answer"] ? element["question"] : "";
  if (keywords.toLowerCase().includes(searchQuery.toLowerCase())) {
    return true;
  } else {
    return false;
  }
}
</script>